import { Component } from '@angular/core';
import { NavController, Events } from 'ionic-angular';
import { LivedataProvider } from '../../providers/livedata/livedata';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  data: any;
  copyright: any = new Date().getFullYear();
  deferredPrompt: any;

  constructor(public navCtrl: NavController, public dataProvider: LivedataProvider, public events: Events) {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
    });
  }

  openWebsite() {
    window.location.href = 'https://montereyboats.com';
  }

  getData() {
    this.dataProvider.getLiveData().then((result: any) => {
      console.log(result);
      this.data = result;
      this.events.publish('data:synced', result);
    });
  }

  addToHome() {
    // Show the prompt
    console.log('runs');
    this.deferredPrompt.prompt();
    this.deferredPrompt.userChoice
      .then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        this.deferredPrompt = null;
      }); 
  }

  needsInstall() {
    // TODO: check if installed
    if (navigator.platform === 'iPhone') {
      return false;
    } else if (navigator.platform === 'iPad') {
      return false;
    } else if (navigator.platform === 'iPod') {
      return false;
    } else {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts